import { ReturnProcessingLevel } from "@redotech/redo-return-settings-primitives-common/return-processing-level";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const getReturnProcessingLevel = unaryRpc({
  name: "getReturnProcessingLevel" as const,
  input: z.object({}),
  output: z.object({
    returnProcessingLevel: z.enum(ReturnProcessingLevel),
    /** Distinct levels across the account-wide level and every returns center. */
    levelsInUse: z.array(z.enum(ReturnProcessingLevel)),
  }),
});
